import DateFnsUtils from "@date-io/date-fns";
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  LinearProgress,
  makeStyles,
  MenuItem,
  Modal,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCountries } from "src/redux/actions/purchaseRequest.action";
import CustomSelectInput from "src/components/inputs/CustomSelectInput";
import { getAllApprover } from "src/redux/actions/backOffice.action";
import { CheckboxWithLabel } from "formik-material-ui";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "30ch",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function ApprovalModal({
  openModalApprove,
  handleCloseModalApprove,
  handleSubmitApproval,
  perid,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const form = useRef();

  const { approver } = useSelector((state) => state.backOfficeReducer);
  const { countries, purchaseRequest } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const {
    result: { countryid },
  } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }

    dispatch(getAllApprover(perid));
    dispatch(getCountries(countryid));

    return () => {};
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openModalApprove}
      onClose={handleCloseModalApprove}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableBackdropClick
    >
      <Fade in={openModalApprove}>
        <div className={classes.paper}>
          {approver.isLoading ? (
            <LinearProgress color="secondary" />
          ) : (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Formik
                ref={form}
                enableReinitialize
                initialValues={{
                  REF_COUNTRY: "",
                  REF_COUNTRY_TYPE: false,
                }}
                validate={(values) => {
                  const errors = {};

                  if (values.REF_COUNTRY_TYPE && !values.REF_COUNTRY) {
                    errors.REF_COUNTRY = "Required";
                  }

                  return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setTimeout(() => {
                    if (!values.REF_COUNTRY_TYPE) {
                      values.REF_COUNTRY = "";
                    }
                    handleSubmitApproval(values.APPROVE_BY, values.REF_COUNTRY);
                    resetForm({
                      values: "",
                    });
                    setSubmitting(false);
                  }, 200);
                }}
              >
                {({ submitForm, errors, touched, isSubmitting, values }) => (
                  <Form noValidate>
                    <Card className={classes.card}>
                      <CardContent>
                        <Grid container spacing={1}>
                          <Box display="flex" flexDirection="column">
                            <Box>
                              <FormControlLabel
                                className={classes.inputForm}
                                label="Reference Country"
                                disabled={Boolean(
                                  purchaseRequest.data.PR_TYPE === 2
                                )}
                                control={
                                  <Field
                                    name="REF_COUNTRY_TYPE"
                                    type="checkbox"
                                    component={CheckboxWithLabel}
                                  />
                                }
                              />
                            </Box>
                            <Box>
                              <FormControl
                                className={classes.inputForm}
                                disabled={Boolean(!values.REF_COUNTRY_TYPE)}
                                error={Boolean(
                                  errors.REF_COUNTRY &&
                                    touched.REF_COUNTRY &&
                                    errors.REF_COUNTRY
                                )}
                              >
                                <InputLabel id="select-countries-label">
                                  Select Country
                                </InputLabel>
                                <Field
                                  component={CustomSelectInput}
                                  name="REF_COUNTRY"
                                  labelId="select-countries-label"
                                  fullWidth
                                  onChange={() => {}}
                                >
                                  <MenuItem key={0} value="">
                                    -
                                  </MenuItem>
                                  {countries.data.map((item) => (
                                    <MenuItem
                                      key={item.ORG_COUNTRY_ID}
                                      value={item}
                                    >
                                      {item.COUNTRY}
                                    </MenuItem>
                                  ))}
                                </Field>
                              </FormControl>
                            </Box>
                          </Box>
                        </Grid>
                      </CardContent>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            m={1}
                            p={1}
                            flexWrap="wrap"
                          >
                            <Box p={1} display="flex" flexDirection="row">
                              <Box mr={5}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Submit
                                </Button>
                              </Box>
                              <Box mr={5}>
                                <Button
                                  onClick={handleCloseModalApprove}
                                  color="default"
                                  raised
                                >
                                  Cancel
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Card>
                  </Form>
                )}
              </Formik>
            </MuiPickersUtilsProvider>
          )}
        </div>
      </Fade>
    </Modal>
  );
}
